import {
    type TextStyle,
    StyleSheet
} from "react-native";
import type {
    QuestionnaireTitleDynamicStyleType
} from "./type";
import type {
    Mutable
} from "../../../../types";

const stylesheet = StyleSheet.create({
    title: {
        flexShrink: 1
    }
});

export const useStyles = ({
    spaces
}: QuestionnaireTitleDynamicStyleType) => {
    const styles = {
        title: {
            marginBottom: spaces.spacingXs
        } as Mutable<TextStyle>
    };

    return styles;
};
export default stylesheet;
